import { Grado } from '../tipologiche/grado';
import { MotivoDefinizione } from '../tipologiche/motivo-definizione';
import { Natura } from '../tipologiche/natura';
import { StatoEntita } from '../tipologiche/stato-entita';
import { TipoFascicolo } from '../tipologiche/tipo-fascicolo';
import { TipoMotivazione } from '../tipologiche/tipo-motivazione';
import { TipoVisibilita } from '../tipologiche/tipo-visibilita';
import { RegistroFascicolo } from './registro-fascicolo';

export class Fascicolo {
  id: string;
  idParent: string;
  tipoFascicolo: TipoFascicolo;
  stato: StatoEntita;
  tipoVisibilita: TipoVisibilita;
  dataDefinizione: number;
  motivoDefinizione: MotivoDefinizione;
  definito: boolean;
  grado: Grado;

  posizione: string;
  vecchiaPosizione: string;

  flagProcessoTelematico: boolean;
  flagFondoRischi: boolean;
  dataVariazioneFondoRischi: number;
  natura: Natura;
  dataInizioFascicolo: number;
  note: string;
  registroFascicolo: RegistroFascicolo;

  dataNotifica: number;
  valorizzazione: boolean;
  flagValorizzazione: boolean;
  dataPrimaComparizione:number;
  dataDepositoRicorso:number;
  descrizioneOggetto:string;
  dataCostituzione:number;
  flagCostituzione:boolean;
  motivazione:TipoMotivazione;
}
